// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';

import type { Result1OfCrmMedewerkersGetMedewerkersVoorContactpaginaDto } from '../model/result1OfCrmMedewerkersGetMedewerkersVoorContactpaginaDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Lijst met interne medewerkers, bedoeld voor de contactpagina.
 */
export const medewerkersGetContactpaginaMedewerkers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Result1OfCrmMedewerkersGetMedewerkersVoorContactpaginaDto>(
    { url: `/api/v1/medewerkers`, method: 'GET', signal },
    options,
  );
};

export const getMedewerkersGetContactpaginaMedewerkersQueryKey = () => {
  return ['api', 'v1', 'medewerkers'] as const;
};

export const getMedewerkersGetContactpaginaMedewerkersQueryOptions = <
  TData = Awaited<ReturnType<typeof medewerkersGetContactpaginaMedewerkers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof medewerkersGetContactpaginaMedewerkers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMedewerkersGetContactpaginaMedewerkersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof medewerkersGetContactpaginaMedewerkers>>
  > = ({ signal }) => medewerkersGetContactpaginaMedewerkers(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof medewerkersGetContactpaginaMedewerkers>>,
    TError,
    TData
  >;
};

export type MedewerkersGetContactpaginaMedewerkersQueryResult = NonNullable<
  Awaited<ReturnType<typeof medewerkersGetContactpaginaMedewerkers>>
>;
export type MedewerkersGetContactpaginaMedewerkersQueryError = ErrorType<unknown>;

/**
 * @summary Lijst met interne medewerkers, bedoeld voor de contactpagina.
 */

export function useMedewerkersGetContactpaginaMedewerkers<
  TData = Awaited<ReturnType<typeof medewerkersGetContactpaginaMedewerkers>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof medewerkersGetContactpaginaMedewerkers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMedewerkersGetContactpaginaMedewerkersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
